// extracted by mini-css-extract-plugin
export var container = "_rg-0";
export var dotAnimation = "_rg-2";
export var dotsLoading = "_rg-1";